export const Environment = {
  BACKEND_API: process.env.REACT_APP_BACKEND_API,
  REGION: process.env.REACT_APP_REGION,
  USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
  USER_POOL_WEB_CLIENT_ID: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
  DOMAIN_NAME: process.env.REACT_APP_DOMAIN_NAME,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
};
